export default __webpack_public_path__ + "static/media/misc-pantry1-1920w.522b2c7d.png";